module.exports = __webpack_public_path__ + "static/media/dashboard-icon-active.269b4f6f.svg";